import {ofType} from 'redux-observable';
import {mergeMap, switchMap} from 'rxjs/operators';

export abstract class BasicEpic {

    protected epicNames: string[];

    static createEpic(type, mapProject, useSwitchMap = true) {
        type = Array.isArray(type) ? type : [type];
        return (action$, store, dependencies) => {
            return action$.pipe(
                ofType(...type),
                useSwitchMap ? switchMap(mapProject) : mergeMap(mapProject)
            );
        };
    }

    epics() {
        return this.epicNames.map(epicName => {
            return ((name) =>
                    (action$, store, dependencies) => this[name](action$, store, dependencies)
            )(epicName);
        });
    }

}
